import React from "react";
import { SizedBox } from "../../../components/layout/sized-box";
import { Typography } from "../../../components/typography/typography";
import { useWindowResize } from "../../../hooks/use-windows-resize";

export const LandingFooter = () => {
    const { isMobile } = useWindowResize();
    return (
        <SizedBox
            data-testid="LandingFooter"
            className="landing-footer"
            width={isMobile ? 300 : 488}
        >
            <Typography fontSize={12}>
                <p>*Beneficios del seguro sujetos a cambios</p>
                <br></br>
                <p>
                    Aplican Términos, Condiciones y Exclusiones que puedes
                    revisar en https://www.pacifico.com.pe/
                    seguros/vida-ley/documentos
                    <br></br>
                    <br></br>
                </p>
                <p>
                    El Seguro de Vida Ley es un producto ofrecido por Pacífico
                    Compañía de Seguros y Reaseguros. Código de registro SBS N°
                    VI2007310027
                </p>
            </Typography>
        </SizedBox>
    );
};
